<h2 mat-dialog-title>Open with...</h2>

<mat-dialog-content *ngFor="let row of resolversGrid" fxLayout="row" fxLayoutAlign="start start">
    <ng-container *ngFor="let resolver of row">
        <button mat-button fxFlex="33" fxLayout="column" fxLayoutAlign="center start"
                (click)="onIntentClicked(resolver)">
            {{resolver.handler.Name}}
        </button>
    </ng-container>
</mat-dialog-content>
